/* eslint-disable react-hooks/exhaustive-deps */
import { CompassUserContext } from '@orientaction/Context';
import { userService } from '@orientaction/services';
import { getFromLS } from '@orientaction/utils';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const AdminCompassUserProvider = ({ children }: any) => {
  const [loading, setLoading] = useState(true);
  const [userInfos, setUserInfos] = useState<any>();
  const { userId }: any = useParams();
  const token = getFromLS('userToken') || '';

  useEffect(() => {
    let cancelled = false;

    const loadBeneficiary = async () => {
      if (!userId || !token) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await userService.getUserById({ token, userId });
        if (!cancelled) {
          setUserInfos(response?.data || response);
        }
      } catch (error) {
        console.error(error);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadBeneficiary();

    return () => {
      cancelled = true;
    };
  }, [userId, token]);

  return (
    <CompassUserContext.Provider value={{ userInfos, loading, adminView: true }}>
      {children}
    </CompassUserContext.Provider>
  );
};

export default AdminCompassUserProvider;
